import React, {useState} from 'react'
import axios from "axios"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'

toast.configure()

const ContactBanner = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [number, setNumber] = useState('');
    const [message, setMessage] = useState('');

    const notify = () => toast("✅ Thank you! We'll be in touch shortly.");

    const handleOnSubmit = e => {
        e.preventDefault();
        const form = e.target;

        axios({
            method: "post",
            url: "https://getform.io/f/ffbd67d3-0f6c-4bbb-a350-b1253c6ef9ca",
            data: new FormData(form)
        })
        .then(r => {
            {notify()}
            setName('');
            setEmail('');
            setNumber('');
            setMessage('');
        })
        .catch(r => {
            console.log('and that.');
        });
    }

    return (
        <section className="main">
            <div className="container">
                <div className="row">
                    <div className="flex flex-row items-center">
                        <div className="w-1/3">
                            <h2 className="text-3xl font-bold tracking-tight text-black">Let's talk.</h2>
                                <p className="splurge-small">Please fill in our form and we'll get straight back to you or at a time convenient for you. Please let us know if you would like us to call or email you, or we can chat online.</p>
                                <p className="mt-1 splurge-small">We look forward to hearing from you.</p>
                        </div>
                        <div className="w-2/3">
                            <form onSubmit={handleOnSubmit}>
                                <div className="flex flex-col md:flex-row">
                                    <div className="w-1/2 px-3 space-y-2">
                                        <div>
                                            <label htmlFor="name" className="block">
                                                <span className="text-gray-700">Name</span>
                                                <input onChange={(e) => setName(e.target.value)} value={name} className="block w-full mt-1 form-input" placeholder="What can we call you?" name="name" data-kw-rules="required|max:10|min:2"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block">
                                                <span className="text-gray-700">Email address</span>
                                                <input onChange={(e) => setEmail(e.target.value)} value={email} type="email" className="block w-full mt-1 form-input" placeholder="john@example.com" name="email" data-kw-rules="required|email"/>
                                            </label>
                                        </div>
                                        <div>
                                            <label htmlFor="phone" className="block">
                                                <span className="text-gray-700">Telephone number</span>
                                                <input  onChange={(e) => setNumber(e.target.value)} value={number} type="text" className="block w-full mt-1 form-input" placeholder="If you would like us to call you" name="phone"/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="w-1/2 px-3 space-y-2">
                                        <div className="">
                                            <label htmlFor="enquiry" className="block">
                                                <span className="text-gray-700">Information</span>
                                                <textarea  onChange={(e) => setMessage(e.target.value)} value={message} className="block w-full mt-1 form-textarea" rows="5" placeholder="Please give us as much information as you'd like." name="enquiry"></textarea>
                                            </label>
                                        </div>
                                        <div>
                                            <button type="submit" className="w-full py-2 text-white bg-black rounded">Send</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default ContactBanner
